import { hbs } from 'ember-cli-htmlbars';
export default hbs("<div class={{class-names \"bv-stack__item\" (if @fill \"bv-stack__item--fill\")}} ...attributes>\n  {{yield}}\n</div>")